"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _updateDeletedSourceInProgram = require("./updateDeletedSourceInProgram");
Object.keys(_updateDeletedSourceInProgram).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _updateDeletedSourceInProgram[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _updateDeletedSourceInProgram[key];
    }
  });
});